export const PRODUCT_LIST = [
  { key: "diacurex_capsules", label: "Diacurex Capsules" },
  { key: "diacurex_powder", label: "Diacurex Powder" },
  { key: "diachol_powder", label: "Diachol Powder" },
  { key: "karela_jamun_powder", label: "Karela Jamun Powder" },
  { key: "paachan_pro_powder", label: "Paachan Pro Powder" },
  { key: "liver_detox_capsules", label: "Liver Detox Capsules" },
  { key: "giloy_tulsi_powder", label: "Giloy Tulsi Powder" },
  { key: "stamina_booster_powder", label: "Stamina Booster Powder" },
  { key: "piles_curex_kit", label: "Piles Curex Kit" },
  { key: "shilahsva_capsules", label: "Shilahsva Capsules" },
];
